import React, { useEffect } from 'react';
import GeneralUtility from '../../utilities/generalUtility';
import ClientStorageService from '../../API/ClientStorage';

const get = (keys, cancel) => {
    let rejector;

    const promise = new Promise((resolve, reject) => {
        const ClientStorageBrowse = ClientStorageService.browse();
        rejector = reject;
        ClientStorageBrowse.request
            .then(data => {
                const obj = {};
                Object.keys(data).forEach(dataKey => {
                    if (keys.includes(dataKey)) {
                        obj[dataKey] = data[dataKey];
                    }
                });
                return resolve(obj);
            })
            .catch(e => {
                return reject(e);
            });
    });

    return cancel
        ? {
              promise,
              cancel: () => {
                  rejector('cancel');
              }
          }
        : promise;
};

const set = (name, value) => {
    const promise = new Promise((resolve, reject) => {
        const x = {};
        x[name] = value;
        const ClientStorageEdit = ClientStorageService.edit(x);
        ClientStorageEdit.request.then(data => resolve(data)).catch(e => reject(e));
    });

    return promise;
};

const ClientStorage = {
    get,
    set
};

export default ClientStorage;
